<template>
  <div>
    <div v-if="loading" class="loader"></div>
    <h3 align="center" v-if="loading">Loading Data...</h3>
    <div v-if="!loading">
      <table>
        <thead>
        <tr>
            <th v-for="(col) in activelogs.columns" :key="col.id">
            {{ col}}
            </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(rw, item) in activelogs.data" :key="item">
            <td>{{ rw.master_hotel_code }}</td>
            <td>{{ rw.master_name }}</td>
            <td>{{ rw.master_address }}</td>
            <td>{{ rw.master_city }}</td>
            <td>{{ rw.master_country }}</td>
            <td>{{ rw.supplier_hotel_code }}</td>
            <td>{{ rw.supplier_name }}</td>
            <td>{{ rw.supplier_address }}</td>
            <td>{{ rw.supplier_city }}</td>
            <td>{{ rw.supplier_country }}</td>
            <td>{{ rw.supplier }}</td>
            <td>{{ rw.name_similarity }}</td>
            <td>{{ rw.address_similarity }}</td>
            <td>{{ rw.geo_distance_km }}</td>
            <td>{{ rw.match_confidence }}</td>
        </tr>
        </tbody>
    </table>
    </div>
  </div>
</template>
<script>

import * as XLSX from "xlsx";
import axios from '@axios'
import JSZip from 'jszip';
import { BRow, BCol, BSpinner, BButton, BFormSelect, BFormSelectOption, BPopover, BIcon } from "bootstrap-vue"
// export default {
//   components: {
//     BRow, BSpinner,
//     BCol, BButton,
//     BFormSelect, BFormSelectOption, BPopover, BIcon
//   },
export default {
components: {
},
  data() {
    return {
      isLoading: false,
      verificationstatus: null,
      loading: true,
      activelogs: null,
      status: null,
      userName: '',
      city: '',
      country: '',
      date: '',
      time: '',
      error: '',
      status2: '',
      suppliers: '',
      flag: '',
      search: '',
      response: '',
      response_status: '',
      end_time: '',
      time_taken: '',
      source: '',
      osm_response: '',
      jsonData1: {
        Title: 'Search Logs',
        Time: '',
        Date: '',
        Search: '',
      },
      jsonData2: {
        Title: 'Response Logs',
        Time: '',
        Date: '',
        Time_Taken: '',
        Response: '',
      },
      jsonData3: {
        Response: ''
      },
      filterText1: '',
      filterText2: '',
      filterText3: '',
      filterText4: '',
      filterText5: '',
      currentPage: 1,
      itemsPerPage: 200, // Number of items per page
      // currentPage: 1, // Current active page
      totalPages: null, // Replace with the actual total number of pages
      goToPageInput: null, // Input for "Go to Page"
      userList:null,
      nodata:false,
      isDownloading:false,
      downCliked:false,
    }
  },
  methods: {
    
    MatchingData: function () {
      axios.post('dataverify', {
        // headers: { 'Access-Control-Allow-Origin': '*' }
      }).then(response => {
        this.activelogs = response.data.data;
        console.log('this.activelogs', response.data)
        console.log(this.loading)
        this.isLoading = false;
        this.loading = false;
        // this.totalPages = response.data.logs.pagination.total_pages
        // alert(this.totalPages)
      }).catch(error => {
        // console.log("Something went wrong in countryGetList()")
      })
    },
  },
  mounted() {
    // this.Error()
    // this.Refreshcount()
    this.MatchingData()
    
    // axios.get('usernames/').then(response => {
    //     console.log("response.data",response.data);
    //     this.userList = response.data;
    //   }).catch(error => {
    //     // console.log("Something went wrong in countryGetList()")
    //   })

    // this.loading = false;

  },
  computed: {


    },
}
</script>
<style>
.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 75px;
  height: 75px;
  animation: spin 1s linear infinite;
  margin: 20px auto;
  margin-top: 200px;
}

.verify {
  margin-left: 10px;

}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.gap {
  margin-right: 5px;
  border-color: black;
  width: 250px;
}
.large-icon {
  transform: scale(1.2);
  transform-origin: center;
}
.gap2 {
  margin-top: 10px;
  border-color: black;
  width: 15%;
  background: white;
}

.gap3 {
  margin-left: 5px;
  margin-top: 5px;
}

.gap4 {
  margin-left: 20px;
  width: auto !important;
  height: 48px;
}

.gap5 {
  margin-left: 20px;
  width: 120px;
  height: 48px;
}

button .spinner-border .sr-only{
  display: none !important;
}
.info {
  padding-left: 20px;
}

.info2 {
  padding-left: 5px;
}

.span_space {
  margin-right: 10px;
}

.active-page {
  background-color: #007bff;
  color: white;
  font-weight: bold;
}

.hhsna {
  width: 10%;
  height: 34px;
  padding: 10px;
  border: thin solid #ddd;

}

.hsggaf {
  height: 34px;
  width: 60px;
}

.pagination-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.parabase {
  margin: 0;
  padding: 0 10px 0 0;
  font-size: 12px;
  color: #606060;
}

.pagination {
  display: inline-block;
  justify-content: center;
}

.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
}

.pagination a.active {
  background-color: #4CAF50;
  color: white;
  border-radius: 5px;
}

.pagination a:hover:not(.active) {
  background-color: #ddd;
  border-radius: 5px;
}

.dosyun {
  display: block !important;
  margin: 5rem auto;
  padding: 1rem;

}
</style>
<script setup>
const userType = localStorage.getItem('userType');
</script>
